import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import {Row, Col} from 'react-bootstrap';
import withAlerts from '../../lib/withAlerts';
import {compose} from '../../lib/compose';
import {useForm} from "react-hook-form";
import {useEUMessagesMutations} from './alertsMutations';
import cx from 'classnames';
import {defaults} from './alertDefaults';
import {usePortalContext} from '../../lib/context/portalContext';
import {useCustomerContext} from '../../lib/context/customerContext';

const AlertDetail = ({alerts = {}}) => {
  const {rowData, togglePortal} = usePortalContext();
  const {success, error} = alerts;
  const {edit} = useEUMessagesMutations();
  const {issue_code, issue_message, action_message} = rowData ?? {};
  const {hasPermission} = useCustomerContext();
  const { register, handleSubmit, formState: {errors} } = useForm({
    mode: 'onBlur'
  });

  // RBAC: ALERT_MSG_EDIT - "On off-canvas: (a) Disable the 'Action Message'
  // textbox; (b) Disable the 'Submit' button."
  const messageEditDisabled = !hasPermission('ALERT_MSG_EDIT');

  const handleMessages = async (formData) => {
    const newMessage = formData?.message?.replace(/(\r\n|\n|\r)/gm, "");

    if(newMessage === action_message) {
      togglePortal();
      return;
    }
    
    const shape = [];

    //reshape the formData
    shape.push({
      issue_code: issue_code,
      action_message: newMessage
    });
    
    const editMessaging = await edit({variables: {messages: shape}});
    if(editMessaging?.errors) {

      const userFacingError = ('Editing Action Message failed.');
      console.error(userFacingError + JSON.stringify(editMessaging?.errors));
      error({msg: userFacingError});
      
    } else {
      success({msg: `Action Message updated.`});
      togglePortal();
    }
  }
  
  return ( 
    <div className="offcanvas-form edit-alerts-modal-body">
      <Form className="mb-3" onSubmit={handleSubmit(handleMessages)}>
        <Row>
          <Col className="mb-3">
            <Form.Group>
              <Form.Label>Issue Message</Form.Label>
              <p className="edit-alerts-modal-text">{issue_message}</p>  
            </Form.Group>
          </Col>
        </Row>
        
        <Row>
          <Col className="mb-3">
            <Form.Group>
              <Form.Label>Action Message</Form.Label>
              <Form.Control
              {...register('message', {
                value: action_message,
                maxLength: {
                  value: 64,
                  message: "Length of Message exceeds 64 characters."
                }
              })}
              as="textarea"
              placeholder={defaults[issue_code]}
              disabled={messageEditDisabled}
              className={cx('mb-1', {'error-input': errors.message })}
              />
              <small className="edit-alerts-modal-text"><em>Default: {defaults[issue_code]}</em></small>
            </Form.Group>
            
          </Col>
        </Row>
        
        <Row>
          <Col>
            {errors?.message && 
              <strong>Length of Message exceeds 64 characters.</strong>
            }  
          </Col>
        </Row>
        <div className="d-flex justify-content-end pt-3">
          {/* <Button onClick={handleClose} variant="secondary">Cancel</Button>  */}
          <Button type="submit" className="ms-2" disabled={messageEditDisabled || errors?.message}>Submit</Button> 
        </div>
        
      </Form>
    </div>
  )
}

export default compose(
  withAlerts
)(AlertDetail);
